export default __webpack_public_path__ + "static/166-19e2e88ee34e0aa1eceb8d10eb44a383.jpg";